import { render, staticRenderFns } from "./IconDeleteFromFolder.vue?vue&type=template&id=a996a058&scoped=true"
import script from "./IconDeleteFromFolder.vue?vue&type=script&lang=js"
export * from "./IconDeleteFromFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a996a058",
  null
  
)

export default component.exports